/**
 * Created by coolguy on 2017/8/10.
 */

import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const redpackageApi = API('redpackage');
const redpackageBalanceApi = API('redpackage_balance');
const redpackageGotApi = API('redpackage_got');
const redpakcageUserApi = API('redpackage_userbatch');
const REDPACKAGE_BALANCE_ADD = "REDPACKAGE_BALANCE_ADD";
const REDPACKAGE_BALANCE_EDIT = "REDPACKAGE_BALANCE_EDIT";
const REDPACKAGE_BALANCE_DETAIL = "REDPACKAGE_BALANCE_DETAIL";
const REDPACKAGE_BALANCE_REMOVE = "REDPACKAGE_BALANCE_REMOVE";
const REDPACKAGE_BALANCE_LIST = "REDPACKAGE_BALANCE_LIST";
const REDPACKAGE_ADD = "REDPACKAGE_ADD";
const REDPACKAGE_EDIT = "REDPACKAGE_EDIT";
const REDPACKAGE_DETAIL = "REDPACKAGE_DETAIL";
const REDPACKAGE_REMOVE = "REDPACKAGE_REMOVE";
const REDPACKAGE_LIST = "REDPACKAGE_LIST";
const REDPACKAGE_USERBATCH_ADD = "REDPACKAGE_USERBATCH_ADD";
const REDPACKAGE_USERBATCH_EDIT = "REDPACKAGE_USERBATCH_EDIT";
const REDPACKAGE_USERBATCH_DETAIL = "REDPACKAGE_USERBATCH_DETAIL";
const REDPACKAGE_USERBATCH_REMOVE = "REDPACKAGE_USERBATCH_REMOVE";
const REDPACKAGE_USERBATCH_LIST = "REDPACKAGE_USERBATCH_LIST";
const REDPACKAGE_USERBATCH_COUNT = "REDPACKAGE_USERBATCH_COUNT";
const REDPACKAGE_GOT_LIST = "REDPACKAGE_GOT_LIST";
const REDPACKAGE_BALANCE_TOTAL = "REDPACKAGE_BALANCE_TOTAL";

export default {
    REDPACKAGE_USERBATCH_COUNT,
    redpackageUserbatchCount: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:redpakcageUserApi('get')('count'),
            data:search,
            success: (data)=>({
                type:REDPACKAGE_USERBATCH_COUNT,
                data
            })
        })
    },
    REDPACKAGE_USERBATCH_ADD,
    redpackageUserbatchAdd : (params)=>{
        return ajaxCommon({
            api:redpakcageUserApi('post')(),
            data:params,
            success:(data)=>({
                type:REDPACKAGE_USERBATCH_ADD,
                data
            })
        })
    },
    REDPACKAGE_USERBATCH_EDIT,
    redpackageUserbatchEdit:(id,info)=>{
        return ajaxCommon({
            api:redpakcageUserApi('put')(id),
            data:info,
            success:(data)=>({
                type:REDPACKAGE_USERBATCH_EDIT,
                data,
            })
        })
    },
    REDPACKAGE_USERBATCH_DETAIL,
    redpackageUserbatchDetail:(id)=>{
        return ajaxCommon({
            api:redpakcageUserApi('get')(id),
            success:(data)=>({
                type:REDPACKAGE_USERBATCH_DETAIL,
                data,
            })
        })
    },
    REDPACKAGE_USERBATCH_REMOVE,
    redpackageUserbatchRemove:(id)=>{
        return ajaxCommon({
            api:redpakcageUserApi('delete')(id),
            success:(data)=>({
                type:REDPACKAGE_USERBATCH_REMOVE,
                data,
            })
        })
    },
    REDPACKAGE_USERBATCH_LIST,
    redpackageUserbatchList: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:redpakcageUserApi('get')(),
            data:search,
            success: (data)=>({
                type:REDPACKAGE_USERBATCH_LIST,
                data
            })
        })
    },
    REDPACKAGE_GOT_LIST,
    redpackageGotList: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:redpackageGotApi('get')(),
            data:search,
            success: (data)=>({
                type:REDPACKAGE_GOT_LIST,
                data
            })
        })
    },
    REDPACKAGE_BALANCE_ADD,
    redpackageBalanceAdd : (params)=>{
        return ajaxCommon({
            api:redpackageBalanceApi('post')(),
            data:params,
            success:(data)=>({
                type:REDPACKAGE_BALANCE_ADD,
                data
            })
        })
    },
    REDPACKAGE_BALANCE_EDIT,
    redpackageBalanceEdit:(id,info)=>{
        return ajaxCommon({
            api:redpackageBalanceApi('put')(id),
            data:info,
            success:(data)=>({
                type:REDPACKAGE_BALANCE_EDIT,
                data,
            })
        })
    },
    REDPACKAGE_BALANCE_DETAIL,
    redpackageBalanceDetail:(id)=>{
        return ajaxCommon({
            api:redpackageBalanceApi('get')(id),
            success:(data)=>({
                type:REDPACKAGE_BALANCE_DETAIL,
                data,
            })
        })
    },
    REDPACKAGE_BALANCE_REMOVE,
    redpackageBalanceRemove:(id)=>{
        return ajaxCommon({
            api:redpackageBalanceApi('delete')(id),
            success:(data)=>({
                type:REDPACKAGE_BALANCE_REMOVE,
                data,
            })
        })
    },
    REDPACKAGE_BALANCE_LIST,
    redpackageBalanceList: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:redpackageBalanceApi('get')(),
            data:search,
            success: (data)=>({
                type:REDPACKAGE_BALANCE_LIST,
                data
            })
        })
    },
    REDPACKAGE_BALANCE_TOTAL,
    redpackageBalanceTotal: (galleryid)=>{
        return ajaxCommon({
            api:redpackageBalanceApi('get')('total'),
            data:{
                galleryid
            },
            success:(data)=>({
                type:REDPACKAGE_BALANCE_TOTAL,
                data
            })
        });
    },
    REDPACKAGE_ADD,
    redpackageAdd : (params)=>{
        return ajaxCommon({
            api:redpackageApi('post')(),
            data:params,
            success:(data)=>({
                type:REDPACKAGE_ADD,
                data
            })
        })
    },
    REDPACKAGE_EDIT,
    redpackageEdit:(id,info)=>{
        return ajaxCommon({
            api:redpackageApi('put')(id),
            data:info,
            success:(data)=>({
                type:REDPACKAGE_EDIT,
                data,
            })
        })
    },
    REDPACKAGE_DETAIL,
    redpackageDetail:(id)=>{
        return ajaxCommon({
            api:redpackageApi('get')(id),
            success:(data)=>({
                type:REDPACKAGE_DETAIL,
                data,
            })
        })
    },
    REDPACKAGE_REMOVE,
    redpackageRemove:(id)=>{
        return ajaxCommon({
            api:redpackageApi('delete')(id),
            success:(data)=>({
                type:REDPACKAGE_REMOVE,
                data,
            })
        })
    },
    REDPACKAGE_LIST,
    redpackageList: (search)=>{
        search.page = search.page || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:redpackageApi('get')(),
            data:search,
            success: (data)=>({
                type:REDPACKAGE_LIST,
                data
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/RedpackageAction.js